import Configurations from '@/modules/common/common/models/APP/Configuration'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import schema from '@/modules/health/common/schemas/APP/HealthConfigurationsSchema'
import {
  CopaymentTypes,
  InsuranceTypes,
  StayAbroadTypes
} from '@/modules/health/rater/models/DXP/ConfigurationsProperties'
import HealthConfigurationTags from './HealthConfigurationTags'

import type TagAlertValue from '@/modules/core/models/TagAlertValue'
import { validate } from '@/utils/schemaValidatorUtils'
import { HealthMinMaxAges } from './HealthMinMaxAges'

export default class HealthConfigurations extends Configurations<HealthMinMaxAges> {
  copaymentTypes!: CopaymentTypes
  insuranceTypes!: InsuranceTypes
  stayAbroadTypes?: StayAbroadTypes
  tags!: any
  defaultHiringMaxAges!: HealthMinMaxAges
  hiringMaxAgesInternationalWork?: HealthMinMaxAges
  hiringMaxAgesInternationalStudy?: HealthMinMaxAges
  startDateHint?: TagAlertValue | null

  constructor(data?: HealthConfigurations) {
    validate(schema, data)

    super(data)

    if (data?.stayAbroadTypes) {
      this.stayAbroadTypes = new StayAbroadTypes(data.stayAbroadTypes)
    }

    if (data?.copaymentTypes) {
      this.copaymentTypes = new CopaymentTypes(data.copaymentTypes)
    }

    if (data?.insuranceTypes) {
      this.insuranceTypes = new InsuranceTypes(data.insuranceTypes)
    }

    if (data?.tags) {
      this.tags = new HealthConfigurationTags(data.tags)
    }

    if (data?.hiringMaxAges) {
      this.hiringMaxAges = new HealthMinMaxAges(data.hiringMaxAges)
    }

    if (data?.hiringMaxAgesInternationalWork) {
      this.hiringMaxAgesInternationalWork = new HealthMinMaxAges(
        data.hiringMaxAgesInternationalWork
      )
    }

    if (data?.hiringMaxAgesInternationalStudy) {
      this.hiringMaxAgesInternationalStudy = new HealthMinMaxAges(
        data.hiringMaxAgesInternationalStudy
      )
    }

    if (data?.defaultHiringMaxAges) {
      this.defaultHiringMaxAges = new HealthMinMaxAges(data.defaultHiringMaxAges)
    }
  }

  get copaymentTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.copaymentTypes)
  }
  get defaultCopaymentType(): string | null {
    return this.getDefaultValue(this.copaymentTypes)
  }

  get insuranceTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.insuranceTypes)
  }
  get defaultInsuranceType(): string | null {
    return this.getDefaultValue(this.insuranceTypes)
  }

  get stayAbroadTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.stayAbroadTypes)
  }
  get defaultStayAbroadType(): string | null {
    return this.getDefaultValue(this.stayAbroadTypes)
  }
}
